import { gql } from '@apollo/client';

export const GET_PROJECTS = gql`
query getProjects($input: GetProjectsInput){
  getProjects(input: $input){
    projectId
    projectDisplayId
    projectName
    projectDesc
    status
    ownerId
    createdAt
    parentProjectId
    parentProjectName
    userIdArr
  }
}`;

export const GET_PROJECT_HIERARCHY = gql`
query getProjectsHirachy($input: GetProjectsHirachyInput) {
  getProjectsHirachy(input: $input){
    projectsCount{
      total
      completed
      failed
      inProgress
    }
    projects
  }
}
`;

export const GET_PROJECT_AND_RECON_CONFIG_DETAILS = gql`
query getProjectAndReconConfigDetails($input: GetProjectAndReconConfigInput) {
  getProjectAndReconConfigDetails(input: $input){
    projectDetails{
      projectId
      projectDisplayId
      ownerName
      projectName
      projectDesc
      status
      reconRunStatus
      ownerId
      createdAt
      parentProjectId
      parentProjectName
      userIdArr
      fileMatchIds
    }
    childProjectArr
    fileInfoArr{
      fileId
      noOfRecords
      noOfColumns
      fileName
      fileDisplayName
      columnDetails
      fileData
      DQScore
    }
  }
}
`;

export const GET_DIRECTORY_DETAILS = gql`
query DQgetDirDetails($dirId:Int) {
  DQgetDirDetails(dirId:$dirId){
    dirId
    dirName
    parentDirId
    dirTree {
      idx
      dirName
      dirId
    }
     dirContents {
      id
      name
      type
      fileSize
      dateAdded
      owner
    }
  }
}
`;

export const DOWNLOAD_FILE = gql`
query DQdownloadFile($fileId: Int!) {
  DQdownloadFile(fileId: $fileId){
    fileId
    fileName
    fileData
  }
}
`;
